<template>
  <PortalPageShell
    :title="pageTitle"
    :subtitle="pageSubtitle"
  >
    <div class="portal-form-card edit-claim form-group">
      <div class="my-2">
      <div class="loader" v-if="loading"></div>
      <input class="form-control" type="text" id="display_name" :placeholder="$t('claim.editclaim.name')" v-model="claim.display_name"/><br>
      <div v-if="this.$router.currentRoute.name == 'edit-claim'" class="custom-control custom-switch">
        <input type="checkbox" class="custom-control-input" id="customSwitches" v-model="claim.is_active"/>
        <label class="custom-control-label mt-4" for="customSwitches">{{ $t("claim.editclaim.isactive") }}</label>
      </div>
    </div>
    <button v-if="this.$router.currentRoute.name == 'new-claim'" class="btn btn-success" @click="addClaim">{{ $t ("claim.newClaim.claim-btn") }}</button>
    <button v-if="this.$router.currentRoute.name == 'edit-claim'" class="btn btn-primary" @click="updateClaim($route.params.editid)">{{ $t("claim.editclaim.btn") }}</button>
    </div>
  </PortalPageShell>
</template>
<script>
import PortalPageShell from '../layout/PortalPageShell.vue';
import axios from 'axios';
import { routeNames } from '../../js/routeNames';
export default {
  name: 'Claim',
  components: {
    PortalPageShell,
  },
  data: function () {
    return {
      loading: false,
      claimData: '',
      switchValue: false,
      claim: {
        display_name: '',
        is_active: '',
      },
      nameCheck: ''
    };
  },
  mounted() {
    if(this.$router.currentRoute.name == 'edit-claim'){
      this.claim.display_name = this.$route.params.display_name;
      this.claim.is_active = this.$route.params.is_active;
      this.nameCheck = this.$route.params.display_name;
    }
  },
  computed: {
    routeNames: () => {
      return routeNames;
    },
    pageTitle() {
      return this.$router.currentRoute.name === 'new-claim'
        ? this.$t('claim.newClaim.title')
        : this.$t('claim.editclaim.title');
    },
    pageSubtitle() {
      return this.$t('portal.claimManager');
    },
  },
  methods: {
    getOne(idx) {
      axios.get(this.$hostName + '/claim/' + idx).then((response) => {
        this.claimData = response.data;
      });
    },
    addClaim(){
      if(this.claim.display_name==''){
        this.$alert('Enter Claim Name');
      }
      else{
        this.loading =  true;
        axios.post(this.$hostName + '/claim/store',{
          claim: this.claim
        })
        .then( response =>{
          if(response.status==202){
              this.loading = false;
              this.$alert('Claim Already Exists');
            }
          else{
            this.claim.display_name='';
            this.loading =  false;
            this.$router.push({name:routeNames.manageClaim});
          }
        })
        .catch(error=>{
          console.log(error);
        });
      }
    },
    updateClaim(idx) {
      if (this.claim.display_name == '') {
        this.$alert('Enter Claim Name');
      } else {
        this.loading = true;
        axios
          .put(this.$hostName + '/claim/' + idx, {
            claim: this.claim,
            nameCheck: this.nameCheck
          })
          .then((response) => {
            if (response.status == 202) {
              this.loading = false;
              this.$alert('Claim already exists');
            } else {
              this.loading = false;
              this.$router.push({name: routeNames.manageClaim});
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    goToRoute(route) {
      if (this.navOpen) this.toggleNav();
      if (route == this.$router.currentRoute.name) return;
      this.$router.push({ name: route });
    },
  },
};
</script>
<style scoped>
.loader {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: #eceaea;
  background-image: url('../../assets/loading.gif');
  background-size: 50px;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 10000000;
  opacity: 0.4;
  filter: alpha(opacity=40);
}
</style>
